import { render, staticRenderFns } from "./KundeWohnungOverview.vue?vue&type=template&id=64d97fa4&"
import script from "./KundeWohnungOverview.vue?vue&type=script&lang=js&"
export * from "./KundeWohnungOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports